import config from "./config.local.shared.json";

const servers = [
  {
    url: config.parameters.urls.api,
    description: "Server"
  }
];

export default {
  apis: servers
};
